export default __webpack_public_path__ + "static/streamline-expense-reporting-for-a-tech-company-3db53e56aa53119d8d953a4714e70fd3.jpg";